import { Button, Modal } from "@xola/ui-kit";
import clsx from "clsx";
import React, { useState } from "react";
import { Announcement, AnnouncementAction, AnnouncementActionDestination, AnnouncementActionType } from "types";

interface AnnouncementActionProps {
    announcement: Announcement;
    className?: string;
}

export const AnnouncementActions = ({ announcement, className }: AnnouncementActionProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [action, setAction] = useState("");

    const handleModalToggle = (value: boolean, action: string) => {
        setIsOpen(value);
        setAction(action);
    };

    const [anchorActions, buttonActions] = getActionButtons(announcement);

    return (
        <div className={clsx("flex", className)}>
            <AnchorAction actions={anchorActions} onClick={handleModalToggle} />
            <ActionButton actions={buttonActions} onClick={handleModalToggle} />
            <Modal size="huge" isOpen={isOpen} onClose={() => setIsOpen(false)}>
                {/* eslint-disable-next-line react/iframe-missing-sandbox */}
                <iframe className="h-96 w-full" sandbox="allow-same-origin allow-scripts" src={action} />
            </Modal>
        </div>
    );
};

const getActionButtons = (announcement: Announcement) => {
    if (!announcement.actions?.length) {
        return [[], []];
    }

    const anchorActions: AnnouncementAction[] = [];
    const buttonActions: AnnouncementAction[] = [];

    for (const action of announcement.actions) {
        if (action.url !== null) {
            if (action.type === AnnouncementActionType.ANCHOR) {
                anchorActions.push(action);
            } else if (action.type === AnnouncementActionType.BUTTON) {
                buttonActions.push(action);
            }
        }
    }

    return [anchorActions, buttonActions];
};

interface ActionProps {
    actions: AnnouncementAction[];
    onClick: (value: boolean, action: string) => void;
}

export const AnchorAction = ({ actions, onClick }: ActionProps) => {
    return (
        <div className="flex space-x-4">
            {actions.map((action) =>
                action.destination === AnnouncementActionDestination.IFRAME ? (
                    <a
                        key={action.id}
                        className="cursor-pointer text-sm font-bold text-black underline"
                        onClick={() => onClick(true, action.url)}
                    >
                        {action.label}
                    </a>
                ) : (
                    <a
                        key={action.id}
                        className="text-sm font-bold text-black underline"
                        href={action.url}
                        target={action.destination === AnnouncementActionDestination.NEWTAB ? "_blank" : undefined}
                        rel="noreferrer"
                    >
                        {action.label}
                    </a>
                ),
            )}
        </div>
    );
};

export const ActionButton = ({ actions, onClick }: ActionProps) => {
    return (
        <div className="flex pr-4">
            {actions.map((action) =>
                action.destination === AnnouncementActionDestination.IFRAME ? (
                    <Button key={action.id} type="primary" size="small" onClick={() => onClick(true, action.url)}>
                        {action.label}
                    </Button>
                ) : (
                    <a
                        key={action.id}
                        href={action.url}
                        target={action.destination === AnnouncementActionDestination.NEWTAB ? "_blank" : undefined}
                        rel="noreferrer"
                    >
                        <Button type="primary" size="small">
                            {action.label}
                        </Button>
                    </a>
                ),
            )}
        </div>
    );
};
